if (!customElements.get('cart-reward')) {
  customElements.define(
    'cart-reward',
    class CartReward extends HTMLElement {
      constructor() {
        super();

        this.cartUpdateUnsubscriber = theme.pubsub.subscribe(
          theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          this.onCartUpdate.bind(this)
        );
      }

      get variantId() {
        return parseInt(this.getAttribute('data-variant-id'));
      }

      get sectionId() {
        return this.getAttribute('data-section-id');
      }

      get isQualified() {
        return this.getAttribute('data-qualified') === 'true';
      }

      get isInCart() {
        return this.getAttribute('data-in-cart') === 'true';
      }

      get rewardLineKey() {
        return this.getAttribute('data-reward-line-key');
      }

      get thresholdType() {
        return this.getAttribute('data-threshold-type');
      }

      get thresholdValue() {
        return parseInt(this.getAttribute('data-threshold-value'));
      }

      get selectedVariantId() {
        const activeBtn = this.querySelector('.cart-reward__size-btn.is-active');
        return activeBtn ? parseInt(activeBtn.dataset.variantId) : this.variantId;
      }

      get hasSizeOptions() {
        return !!this.querySelector('[data-reward-size-options]');
      }

      connectedCallback() {
        this.addButton = this.querySelector('.cart-reward__add');
        this.addButton?.addEventListener('click', this.onAddClick.bind(this));

        this.sizeOptions = this.querySelector('[data-reward-size-options]');
        this.sizeError = this.querySelector('[data-reward-size-error]');
        this.sizeModal = this.querySelector('[data-reward-size-modal]');
        this.sizeOptions?.addEventListener('click', this.onSizeClick.bind(this));

        if (window._rewardSizeSwapping) {
          window._rewardSizeSwapping = false;
        }
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      onSizeClick(event) {
        const btn = event.target.closest('.cart-reward__size-btn');
        if (!btn) return;

        this.sizeOptions.querySelectorAll('.cart-reward__size-btn').forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        if (this.sizeError) this.sizeError.classList.add('hidden');
      }

      onAddClick(event) {
        event.preventDefault();
        if (this.addButton.hasAttribute('aria-busy')) return;

        if (this.hasSizeOptions && !this.querySelector('.cart-reward__size-btn.is-active')) {
          if (this.sizeError) this.sizeError.classList.remove('hidden');
          return;
        }

        this.addReward();
      }

      async addReward() {
        this.addButton?.setAttribute('aria-busy', 'true');

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const body = JSON.stringify({
          items: [{
            id: this.selectedVariantId,
            quantity: 1,
            properties: { _reward: 'true' }
          }],
          sections: sectionsToBundle
        });

        try {
          const addResponse = await fetch(theme.routes.cart_add_url, {
            ...theme.utils.fetchConfig('javascript'),
            body
          });
          const parsedState = await addResponse.json();

          if (parsedState.status) {
            console.error('Cart reward add error:', parsedState.description);
            this.addButton?.removeAttribute('aria-busy');
            return;
          }

          const cartJson = await (
            await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })
          ).json();
          cartJson['sections'] = parsedState['sections'];

          this.sizeModal?.hide();

          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-reward',
            cart: cartJson
          });
        }
        catch (error) {
          console.error('Cart reward error:', error);
          this.addButton?.removeAttribute('aria-busy');
        }
      }

      async removeReward() {
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const body = JSON.stringify({
          id: this.rewardLineKey,
          quantity: 0,
          sections: sectionsToBundle
        });

        try {
          const response = await fetch(theme.routes.cart_change_url, {
            ...theme.utils.fetchConfig(),
            body
          });
          const parsedState = await response.json();

          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-reward-remove',
            cart: parsedState
          });
        }
        catch (error) {
          console.error('Cart reward remove error:', error);
        }
      }

      onCartUpdate(event) {
        if (event.source === 'cart-reward' || event.source === 'cart-reward-remove' || event.source === 'cart-size-picker') return;

        const cart = event.cart;
        if (!cart?.items) return;

        let currentValue = 0;
        let rewardLineKey = null;

        for (const item of cart.items) {
          if (item.properties?._reward === 'true') {
            rewardLineKey = item.key;
            continue;
          }

          if (this.thresholdType === 'amount') {
            currentValue += item.final_line_price;
          }
          else {
            currentValue += item.quantity;
          }
        }

        if (rewardLineKey && currentValue < this.thresholdValue) {
          this.setAttribute('data-reward-line-key', rewardLineKey);
          this.removeReward();
        }
      }
    }
  );
}
